import { RouterModule } from '@angular/router';

export const ChangeRequestRoutes = RouterModule.forChild([
]);
